import React, { useEffect, useState } from "react";
// import Navbar from "../Navbar";
// import FindLoan from "./FindLoan";
import Serve from "./Serve/Serve.jsx";
import Types from "./Types/Types.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import LoanConsolidationEligibility from "./PersonalLoanEligibility/LoanConsolidationEligibility.jsx";
import PersonalLoanEligibility from "./PersonalLoanEligibility/PersonalLoanEligibility.jsx";
import { useLocation } from "react-router-dom";

const LoanEligibilityForm = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const [loanApplyType, setLoanApplyType] = useState(() => {
    if (
      pathname === "/personal-loan/check-eligibility-form/" ||
      pathname === "/personal-loan/check-eligibility-form"
    ) {
      return "pl";
    } else if (
      pathname === "/car-loan/check-eligibility-form/" ||
      pathname === "/car-loan/check-eligibility-form"
    ) {
      return "cl";
    } else if (
      pathname === "/home-loan/check-eligibility-form/" ||
      pathname === "/home-loan/check-eligibility-form"
    ) {
      return "hl";
    }
  });

  console.log("Current Pathname for e form:", pathname);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* <Navbar /> */}
      <PersonalLoanEligibility loanApplyType={loanApplyType} />

      <Serve loanApplyType={loanApplyType} />
      <Types loanApplyType={loanApplyType} />
      {/* <Footer /> */}
      <ToastContainer loanApplyType={loanApplyType} />
    </>
  );
};

export default LoanEligibilityForm;
